import {Navbar} from "@/components/ui/Navbar.tsx";
import {Timer} from "@/components/ui/Timer.tsx";
import {Cities} from "@/components/ui/Cities.tsx";
import {Toaster} from "@/components/ui/sonner.tsx";
import {useEffect, useState} from "react";

function App() {
    const [fullScreen, setFullScreen] = useState(false)

    useEffect(() => {
        if (fullScreen) document.documentElement.requestFullscreen()
        const exitFullScreen = () => {
            setFullScreen(false)
            if (fullScreen) document.exitFullscreen()
        }

        window.addEventListener("extfullscreen", exitFullScreen)
        return () => window.removeEventListener("extfullscreen", exitFullScreen)
    }, [fullScreen]);

    return <>
        <div className="flex items-center justify-center flex-col">
            <Navbar setFullScreen={setFullScreen} />
            <main className="mt-[100px] container">
                <div className="flex items-center justify-center">
                    <Timer fullScreen={fullScreen} />
                </div>
                <Cities />
            </main>
            <Toaster position="top-center" />
        </div>
    </>
}

export default App;